// extracted by mini-css-extract-plugin
export var deliveryRow = "_ro-a";
export var fixedHeight = "_ro-4";
export var freightLogo = "_ro-9";
export var fullWidth = "_ro-3";
export var priceColumn = "_ro-5";
export var radioSelected = "_ro-7";
export var radioUnselected = "_ro-6";
export var selectedOption = "_ro-2";
export var selectedOptionContainer = "_ro-1";
export var selection = "_ro-0";
export var tallSkeletonText = "_ro-8";